<template>
    <div class="register-container">
      <div class="re-title" >
        <span class="title-name">免费查阅车辆保养维护信息</span>
      </div>
      详细车辆保养维护信息，点击  <a target="_Blank" href="http://qmh.qorosauto.com/dp/static/iP0ANI1xPGAnLtVYZa4p5mM0Ot8YKdptOfutc1I6Sdv.pdf" style="font-size: 15px;font-weight: bold;text-decoration: underline;">车辆保养维护信息浏览</a>
      <div class="re-title" >
        <span class="title-name">独立用户账号申请</span>
      </div>

      <div class="tab-content">
        <span>观致售后维修信息使用权限（包含电子配件目录和维修信息）将以有偿收费方式向用户开放， 收费标准如下：</span>

        <div class="table-content">
          <span>权限&收费标准</span>

          <el-table
              :data="tableData1"
              :header-cell-style="{background:'#D0D0D0', color:'black' }"
              size="mini"
              border
              style="width: 100%">
            <el-table-column
                prop="title"
                label="系统权限">
            </el-table-column>
            <el-table-column
                prop="day"
                label="时限">
            </el-table-column>
            <el-table-column
                prop="charge"
                label="价格">
            </el-table-column>
          </el-table>

        </div>

        <div class="table-content">
          <span>收款方信息如下</span>

          <table class="table  table-bordered el-table el-table--fit el-table--border el-table--enable-row-hover el-table--enable-row-transition el-table--mini">
            <tr class="el-table__row">
              <td style="width: 318px;" colspan="1" rowspan="1" class="el-table_1_column_1"> <div class="cell">收款方式</div></td>
              <td colspan="3"  rowspan="1" style="text-align: center"  class="el-table_1_column_2">  <div class="cell">收款信息</div></td>
            </tr>
            <tr class="el-table__row" style="background-color: #D0D0D0;">
              <td style="width: 318px; color: black "> <div class="cell">银行转账</div></td>
              <td style="color: black"> <div class="cell">观致汇款帐号</div></td>
              <td style="color: black"> <div class="cell">观致汇款银行</div></td>
              <td style="color: black"> <div class="cell">汇款公司名称</div></td>
            </tr>
            <tr class="el-table__row" >
              <td  style="width: 318px;"> <div class="cell">银行转账</div></td>
              <td> <div class="cell">498863325116</div></td>
              <td> <div class="cell">中国银行常熟滨江支行</div></td>
              <td> <div class="cell">观致汽车有限公司</div></td>
            </tr>
            <tr class="el-table__row"  style="background-color: #D0D0D0;">
              <td style="width: 318px; color: black"> <div class="cell">支付宝在线支付</div></td>
              <td colspan="3" style="text-align: center ; color: black"> <div class="cell">支付宝收款码</div></td>
            </tr>
            <tr class="el-table__row" >
              <td style="width: 318px;"> <div class="cell">支付宝在线支付</div></td>
              <td colspan="3">
                <div class="cell"> <a target="_Blank" href="http://qmh.qorosauto.com/dp/static/VtSA8yVMpMhyk4HLzyRXphVbPrsPQUv3XtlVAnR0NXB.png"  style="font-size: 12px;font-weight: bold; margin-left: 41%">点击查看支付宝收款码</a></div>
              </td>
            </tr>
          </table>
        </div>

        <span style="margin-top: 10px">完成付款后，请保留付费的凭证(截图或照片)并在线填写如下申请表格，注册观致经销商门户账号。
          (如有疑问，点击浏览  <a target="_Blank" href="http://qmh.qorosauto.com/dp/static/gWpmK9GCsPMTz4TE9XbXXzSuDmgiPVtstZOi1gQogDu.pdf" >独立用户申请流程</a>)</span>
      </div>

      <div class="form-content">
        <span >账户基本信息</span>
        <hr class="hr-line" />

        <el-form class="form-body"  :rules="basicInfoRules" label-position="right" ref="basicInfoForm" :model="basicInfoForm" label-width="180px" size="mini" autocomplete="off">
          <el-row class="el-row">
            <el-col :span="12">
              <el-form-item class="item" label="用户编号：" prop="loginName">
                <el-input  v-model="basicInfoForm.loginName" disabled></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item class="item" label="中文姓名:" prop="localName">
                <el-input v-model="basicInfoForm.localName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item class="item" label="独立用户类型:" prop="independentUserType">
                <el-select style="width: 100%" v-model="basicInfoForm.independentUserType" placeholder="请选择" @change="independentUserTypeChange">
                  <el-option
                      v-for="item in userTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item class="item" label="姓名拼音:" prop="fullName">
                <el-input v-model="basicInfoForm.fullName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item class="item" label="密码:" prop="userPassword">
                <el-input id="userPassword" autocomplete="new-password" placeholder="密码必须同时包含中英文并且长度大于8小于12"  v-model="basicInfoForm.userPassword" type="text"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item class="item" label="身份证号或护照号:" prop="idNo">
                <el-input v-model="basicInfoForm.idNo"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item class="item" label="重新输入密码:" prop="confirmUserPassword">
                <el-input id="confirmUserPassword" autocomplete="new-password" v-model="basicInfoForm.confirmUserPassword" type="text"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item class="item" label="邮编:">
                <el-input v-model="basicInfoForm.independentUserPostCode"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item class="item" label="国家:" prop="independentUserCountry">
                <el-select style="width: 100%" v-model="basicInfoForm.independentUserCountry" placeholder="请选择" disabled>
                  <el-option
                      v-for="item in countryList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item class="item" label="电话:">
                <el-input v-model="basicInfoForm.telephone"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item class="item" label="地址:" prop="independentUserAddress">
                <el-input  v-model="basicInfoForm.independentUserAddress"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item class="item" label="手机:" prop="mobile">
                <el-input v-model="basicInfoForm.mobile"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item class="item" label="使用目的:">
                  <el-radio-group v-model="basicInfoForm.independentUserIntendedUse" class="register-page" @change="independentUserIntendedUseChange" >
<!--                    <el-radio value="maintain" label="maintain">维修 </el-radio>-->
<!--                    <el-radio value="manage" label="manage"> 经营</el-radio>-->
<!--                    <el-radio value="other" label="other">其他</el-radio>-->
                    <el-radio value="maintain" label="1">维修</el-radio>
                    <el-radio value="manage" label="2">经营</el-radio>
                    <el-radio value="other" label="3">其他</el-radio>
                  </el-radio-group>
                <el-input style="width: 89px" v-model="basicInfoForm.otherReason" :disabled="!isOther"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item class="item" label="邮箱:" prop="email">
                <el-input v-model="basicInfoForm.email"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item class="item" label="是否需要发票:" prop="invoice">
                <el-radio-group v-model="basicInfoForm.invoice" class="register-page">
<!--                  <el-radio value="true" label="true">是</el-radio>-->
<!--                  <el-radio value="false" label="false">否</el-radio>-->
                  <el-radio value="true" label="是">是</el-radio>
                  <el-radio value="false" label="否">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item class="item" label="使用期限:" prop="independentUserUseTime">
                <el-radio-group v-model="basicInfoForm.independentUserUseTime" class="register-page">
<!--                  <el-radio value="oneDay" label="oneDay">一天(300RMB)</el-radio>-->
<!--                  <el-radio value="week" label="week">一周(600RMB)</el-radio>-->
<!--                  <el-radio value="halfYear" label="halfYear">半年(10000RMB)</el-radio>-->
<!--                  <el-radio value="year" label="year">一年(20000RMB)</el-radio>-->
                  <el-radio value="oneDay" label="一天">一天(300RMB)</el-radio>
                  <el-radio value="week" label="一周">一周(600RMB)</el-radio>
                  <el-radio value="halfYear" label="半年">半年(10000RMB)</el-radio>
                  <el-radio value="year" label="一年">一年(20000RMB)</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div class="form-content">
        <span >用户其他信息&付费信息</span>
        <hr class="hr-line" />

        <el-form class="form-body"  :rules="otherInfoRules" label-position="right" ref="otherInfoForm" :model="otherInfoForm" label-width="170px" size="mini">

          <el-row class="el-row" v-if="basicInfoForm.independentUserType =='独立经销商用户'">
            <el-col :span="12">
              <el-form-item class="item" label="所属公司名称:" prop="independentUserCompanyName">
                <el-input  v-model="otherInfoForm.independentUserCompanyName" ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item class="item" label="纳税人联系电话:" prop="taxpayerMobile">
                <el-input v-model="otherInfoForm.taxpayerMobile"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row class="el-row"  v-if="basicInfoForm.independentUserType =='独立经销商用户'">
            <el-col :span="12">
              <el-form-item class="item" label="所属公司地址:" prop="independentUserCompanyAddress">
                <el-input  v-model="otherInfoForm.independentUserCompanyAddress" ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item class="item" label="汇款银行帐号/支付宝账号:" prop="remittanceBankAccount">
                <el-input v-model="otherInfoForm.remittanceBankAccount"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row class="el-row"  v-if="basicInfoForm.independentUserType =='独立经销商用户'">
            <el-col :span="12">
              <el-form-item class="item" label="纳税人识别号:" prop="taxpayerNumber">
                <el-input  v-model="otherInfoForm.taxpayerNumber" ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12"  v-if="basicInfoForm.independentUserType =='独立经销商用户'">
              <el-form-item class="item" label="开户银行/支付宝订单号:" prop="accountBank">
                <el-input v-model="otherInfoForm.accountBank"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row class="el-row"  v-if="basicInfoForm.independentUserType =='独立经销商用户'">
            <el-col :span="12">
              <el-form-item class="item" label="纳税人所在地址:" prop="taxpayerAddress">
                <el-input  v-model="otherInfoForm.taxpayerAddress" ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item class="item" label="营业资质:" prop="businessQualificationPathButton">
                <el-upload
                    class="upload-demo register-page"
                    name="multfiles"
                    action="api/dp/attachment/uploadSingle"
                    :on-remove="handleRemoveBusinessQualification"
                    :on-success="handleSuccessBusinessQualification"
                    :limit="1"
                    :file-list="businessQualificationFileList"
                    accept=".jpg,.png">
                  <el-button size="mini" type="primary" >点击上传</el-button>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row class="el-row"  v-if="basicInfoForm.independentUserType =='独立经销商用户'">
            <el-col :span="12">
              <el-form-item class="item" label="付款凭证:" prop="paymentVoucherPathButton">

                <el-upload
                    class="upload-demo register-page"
                    action="api/dp/attachment/uploadSingle"
                    name="multfiles"
                    :on-remove="handleRemovePaymentVoucher1"
                    :on-success="handleSuccessPaymentVoucher1"
                    :limit="1"
                    :file-list="paymentVoucherFileList1"
                    accept=".jpg,.png">
                  <el-button size="mini" type="primary" >点击上传</el-button>
                </el-upload>

              </el-form-item>
            </el-col>

          </el-row>

          <el-row class="el-row"  v-if="basicInfoForm.independentUserType =='消费者'">
            <el-col :span="12">
              <el-form-item class="item" label="付款凭证:" prop="paymentVoucherPathButton">
                <el-upload
                    class="upload-demo register-page"
                    name="multfiles"
                    action="api/dp/attachment/uploadSingle"
                    :on-remove="handleRemovePaymentVoucher1"
                    :on-success="handleSuccessPaymentVoucher1"
                    :limit="1"
                    :file-list="paymentVoucherFileList1"
                    accept=".jpg,.png">
                  <el-button size="mini" type="primary" >点击上传</el-button>
                </el-upload>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item class="item" label="汇款银行帐号/支付宝账号:" prop="remittanceBankAccount">
                <el-input v-model="otherInfoForm.remittanceBankAccount"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row class="el-row"  v-if="basicInfoForm.independentUserType =='消费者'">

            <el-col :span="12">
            </el-col>

            <el-col :span="12">
              <el-form-item class="item" label="开户银行/支付宝订单号:" prop="accountBank">
                <el-input v-model="otherInfoForm.accountBank"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>
      </div>

      <div class="row bottom-action" style="padding-bottom: 100px;">
        <p>
        <span>
           <el-checkbox v-model="checked">  已阅读并接受
            <a target="_Blank" href="http://qmh.qorosauto.com/dp/static/cmlMeujXKW8szE400qi1E5BxOD7v8SB48DYMzXFbiKq.pdf" >服务协议</a></el-checkbox>
        </span>
          <span class="pull-right">
            <el-button size="mini" @click="submit" style="background-color: #730049;color: #FFF;">提交</el-button>
            <el-button size="mini" @click="reset" style="background-color:#828A90;color: #FFF;">重置</el-button>
            <el-button size="mini" @click="goLogin" style="background-color:#2E3337;;color: #FFF;">返回</el-button>
        </span>
        </p>
        <p>经销商门户网站管理员邮箱 : dp.support@qorosauto.com</p>
      </div>
    </div>
</template>

<script>
import apiDataFilter from "@/utils/apiDataFilter";
import axios from 'axios'

export default {
    data() {
      var validateUserPassword = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('密码必须同时包含中英文且长度大于8小于12'));
        } else {
          var regexp = /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]{8,12}$/
          if(!regexp.test(value)){
            callback(new Error('密码必须同时包含大小写字母及数字且长度大于8小于12'));
          }
          if(this.basicInfoForm.confirmUserPassword != '' &&
              this.basicInfoForm.userPassword != '' &&
            this.basicInfoForm.confirmUserPassword != this.basicInfoForm.userPassword){
            callback(new Error('两次输入密码不一致'));
          }
          callback();
        }
      };
      var validateEmail = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入邮件地址'));
        } else {
          var regexp = /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/
          if(!regexp.test(value)){
            callback(new Error('请输入正确的邮件地址格式'));
          }
          callback();
        }
      };
      var validateIdNo = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入身份证号或护照'));
        } else {
          var regexpIdCard = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$)/
          var regexpPassport = /^1[45][0-9]{7}|G[0-9]{8}|P[0-9]{7}|S[0-9]{7,8}|D[0-9]+$/
          if(!regexpIdCard.test(value) && !regexpPassport.test(value)){
            callback(new Error('请输入正确的身份证号或护照格式'));
          }
          callback();
        }
      };
      var validateMobile =  (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入正确的手机号码格式'));
        } else {
          var regexp = /^1[34578]\d{9}$/
          if(!regexp.test(value)){
            callback(new Error('请输入正确的手机号码格式'));
          }
          callback();
        }
      };
        return {
          checked : false,
          isOther  : false,
          tableData1:[
            { title: '电子配件目录&服务信息',
              day: '一天（1天）',
              charge: '300（RMB）'},
            { title: '电子配件目录&服务信息',
              day: '一周（7天）',
              charge: '600（RMB）'},
            { title: '电子配件目录&服务信息',
              day: '半年（180天）',
              charge: '10000（RMB）'},
            { title: '电子配件目录&服务信息',
              day: '一年（365天）',
              charge: '20000（RMB）'}
          ],
          loginName : "",
          basicInfoForm : {
            loginName : "",
            localName : "" ,
            independentUserType : '独立经销商用户',
            fullName : "",
            userPassword : "",
            idNo : "",
            confirmUserPassword : "",
            independentUserPostCode  :  "",
            independentUserCountry : "中国",
            telephone : "",
            independentUserAddress : "",
            mobile : "",
            independentUserIntendedUseOptions:"" ,
            independentUserIntendedUse : "1",
            email : "",
            invoice : "是",
            independentUserUseTime : "一天",
            otherReason:""
          } ,
          otherInfoForm : {
            independentUserCompanyName : "",
            taxpayerMobile : "",
            independentUserCompanyAddress : "",
            remittanceBankAccount : "",
            taxpayerNumber : "",
            accountBank : "",
            taxpayerAddress : "" ,
            businessQualificationPathButton : "",
            paymentVoucherPathButton : "",
          },
          paymentVoucherFileList1 :[],
          businessQualificationFileList: [],
          userTypeList : [
            // {
            //   value: 'Consumer',
            //   label: '消费者'
            // },
            // {
            //   value: 'Independent_Dealer_User',
            //   label: '独立经销商用户'
            // }
            {
              value: '消费者',
              label: '消费者'
            },
            {
              value: '独立经销商用户',
              label: '独立经销商用户'
            }
          ],
          countryList : [
            // {
            //   value: 'China',
            //   label: '中国'
            // },
            // {
            //   value: 'Italy',
            //   label: '意大利'
            // },
            // {
            //   value: 'Sweden',
            //   label: '瑞典'
            // },
            // {
            //   value: 'Slovak',
            //   label: '斯洛伐克'
            // },
            {
              value: '中国',
              label: '中国'
            },
            {
              value: '意大利',
              label: '意大利'
            },
            {
              value: '瑞典',
              label: '瑞典'
            },
            {
              value: '斯洛伐克',
              label: '斯洛伐克'
            },
          ],
          basicInfoRules:{
            localName: [
              { required: true, message: '请输入中文名称', trigger: 'blur' },
              { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' }
            ],
            fullName : [

              { required: true, message: '请输入姓名拼音', trigger: 'blur' }
            ],
            userPassword : [
              { required: true, message: '密码必须同时包含中英文且长度大于8小于12', trigger: 'blur' },
              { validator: validateUserPassword, trigger: 'blur' }
            ],
            confirmUserPassword : [
              { required: true, message: '密码必须同时包含中英文且长度大于8小于12', trigger: 'blur' },
              { validator: validateUserPassword, trigger: 'blur' }
            ],
            email: [
              { required: true, message: '请输入正确的邮件地址格式', trigger: 'blur' },
              { validator: validateEmail, trigger: 'blur' }
            ],
            idNo : [
              { required: true, message: '请输入正确的身份证号或护照格式', trigger: 'blur' },
              { validator: validateIdNo, trigger: 'blur' }
            ],
            mobile : [
              { required: true, message: '请输入正确的手机号码格式', trigger: 'blur' },
              { validator: validateMobile, trigger: 'blur' }
            ],
            independentUserUseTime : [
              { required: true, message: '请输入正确的手机号码格式', trigger: 'blur' }
            ],
            invoice:[
              { required: true, message: '请选择是否需要发票', trigger: 'blur' }
            ],
            independentUserCountry:[
              { required: true, message: '请选择国家', trigger: 'blur' }
            ],
            independentUserAddress : [
              { required: true, message: '请输入地址', trigger: 'blur' }
            ],
            independentUserType:[
              { required: true, message: '请选择独立用户类型', trigger: 'blur' }
            ],
            loginName : [
              { required: true, message: '请输入用户编号', trigger: 'blur' }
            ]
          },
          otherInfoRules : {
            independentUserCompanyName:[
              { required: true, message: '请输入所属公司名称', trigger: 'blur' }
            ],
            taxpayerMobile:[
              { required: true, message: '请输入纳税人联系电话', trigger: 'blur' }
            ],
            independentUserCompanyAddress : [
              { required: true, message: '请输入所属公司地址', trigger: 'blur' }
            ],
            remittanceBankAccount : [
              { required: true, message: '请输入汇款银行帐号/支付宝账号', trigger: 'blur' }
            ],
            taxpayerNumber : [
              { required: true, message: '请输入纳税人识别号', trigger: 'blur' }
            ],
            accountBank : [
              { required: true, message: '请输入开户银行/支付宝订单号', trigger: 'blur' }
            ],
            taxpayerAddress:[
              { required: true, message: '请输入纳税人所在地址', trigger: 'blur' }
            ],
            businessQualificationPathButton:[
              { required: true, message: '请上传营业资质', trigger: 'blur' }
            ],
            paymentVoucherPathButton : [
              { required: true, message: '请上传付款凭证', trigger: 'blur' }
            ]
          }
        }
    },
    watch: {
      'basicInfoForm.userPassword': function (val) {
        this.setPwdType('userPassword', val)
      },
      'basicInfoForm.confirmUserPassword': function (val) {
        this.setPwdType('confirmUserPassword', val)
      },
    },

    created() {
      this.getMaxRecordByType();
      // this.reset();
    },
    mounted() {
      console.log(this.basicInfoForm)
    },
    methods: {
      setPwdType(id,val){
        let len = val?val.length : 0
        if(len){
          document.getElementById(id).setAttribute('type','password');
        }else{
          document.getElementById(id).setAttribute('type','text');
        }
      },
      submit(){
        if(!this.checked){
          this.$alert('请仔细阅读服务协议！', '提示', {
            confirmButtonText: '确定'
          });
          return
        }

        try {
           Promise.all([
            this.$refs.basicInfoForm.validate(),
            this.$refs.otherInfoForm.validate()
          ]).then((res) => {

            let param ={}
            param.account = this.basicInfoForm.loginName
            param.active = 1
            param.address = this.basicInfoForm.independentUserAddress
            param.bank = this.otherInfoForm.accountBank
            param.businessQualification = this.otherInfoForm.businessQualificationPathButton
            param.chineseName = this.basicInfoForm.localName
             param.companyAddress = this.otherInfoForm.independentUserCompanyAddress
             param.companyName = this.otherInfoForm.independentUserCompanyName
             param.email = this.basicInfoForm.email
             param.englishName = this.basicInfoForm.fullName
             param.mobilePhone = this.basicInfoForm.mobile
             param.needInvoice = this.basicInfoForm.invoice
             param.password = this.basicInfoForm.userPassword
             param.paymentVoucher = this.otherInfoForm.paymentVoucherPathButton

             param.remittanceAccount = this.otherInfoForm.remittanceBankAccount
             // param.roleId = this.basicInfoForm.independentUserType
             param.taxpayerAddress = this.otherInfoForm.taxpayerAddress
             param.taxpayerId = this.otherInfoForm.taxpayerNumber
             param.taxpayerMobilePhone = this.otherInfoForm.taxpayerMobile
             param.telephone = this.basicInfoForm.telephone

             param.timeLimit = this.basicInfoForm.independentUserUseTime
             param.uniqueUserType = this.basicInfoForm.independentUserType
             param.userName = this.basicInfoForm.localName

             param.purposeType = this.basicInfoForm.independentUserIntendedUse
             param.purpose = this.basicInfoForm.otherReason
             console.log(param)
             apiDataFilter.request({
               api: 'register.registerOpe',
               method: 'post',
               data: param
             }).then((res) => {
               if(res.status == 200){
                 this.$message({
                   message: '注册成功！',
                   type: 'success'
                 });
                 this.reset()
                 this.$router.push("/login");
               }else {
                 this.$message({
                   message: '注册失败！',
                   type: 'error'
                 });
               }
             })
          })
        } catch (error) {
          return
        }
      },
      goLogin(){
        this.$router.push("/login");
      },
      reset(){
        this.basicInfoForm = {
          // loginName : "",
          localName : "" ,
          independentUserType : '独立经销商用户',
          fullName : "",
          userPassword : "",
          idNo : "",
          confirmUserPassword : "",
          independentUserPostCode  :  "",
          independentUserCountry : "中国",
          telephone : "",
          independentUserAddress : "",
          mobile : "",
          independentUserIntendedUseOptions:"" ,
          independentUserIntendedUse : "1",
          email : "",
          invoice : "是",
          independentUserUseTime : "一天",
          otherReason:""
        }
        this.otherInfoForm = {
          independentUserCompanyName : "",
          taxpayerMobile : "",
          independentUserCompanyAddress : "",
          remittanceBankAccount : "",
          taxpayerNumber : "",
          accountBank : "",
          taxpayerAddress : "" ,
          businessQualificationPathButton : "",
          paymentVoucherPathButton : "",
        }
        this.$refs.otherInfoForm.clearValidate()
        this.$refs.basicInfoForm.clearValidate()
        this.basicInfoForm.loginName = this.loginName
        this.paymentVoucherFileList1 = []
        this.businessQualificationFileList = []
      },
      independentUserIntendedUseChange(){
        if(this.basicInfoForm.independentUserIntendedUse == 3){
          this.isOther = true
        }else {
          this.isOther = false
          this.basicInfoForm.otherReason  = ""
        }
      },
      independentUserTypeChange(){
        this.otherInfoForm = {
          independentUserCompanyName : "",
              taxpayerMobile : "",
              independentUserCompanyAddress : "",
              remittanceBankAccount : "",
              taxpayerNumber : "",
              accountBank : "",
              taxpayerAddress : "" ,
              businessQualificationPathButton : "",
              paymentVoucherPathButton : "",
        }
        this.$refs.otherInfoForm.clearValidate()
      },
      getMaxRecordByType(){
        apiDataFilter.request({
          api: 'register.getMaxRecordByType',
          method: 'get'
        }).then((res) => {
          this.basicInfoForm.loginName = res.data.result
          this.loginName = res.data.result
        })
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePreview(file) {
        console.log(file);
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      handleRemovePaymentVoucher1(file, fileList) {
        this.otherInfoForm.paymentVoucherPathButton = ""
      },
      handleSuccessPaymentVoucher1(response, file, fileList){
        this.otherInfoForm.paymentVoucherPathButton = response.result.filePath
        this.$refs.otherInfoForm.validate()
      },
      handleRemoveBusinessQualification(file, fileList){
        this.otherInfoForm.businessQualificationPathButton = ""
      },
      handleSuccessBusinessQualification(response, file, fileList){
        this.otherInfoForm.businessQualificationPathButton = response.result.filePath
        this.$refs.otherInfoForm.validate()
      },
    }
}
</script>

<style>
.item .el-form-item__label{
  color: #828A90;
  font-size: 12px !important;
}
.register-page .el-radio__label {
  font-size: 12px !important;
}
.register-page .el-upload-list{
  float: right;
  top: -5px;
  position: relative;
}
</style>

<style lang="less" scoped>
.register-container{
  width: 952px;
  height: 100%;
  margin: 0 auto;
  color: black;
  font-size: 12px;
}

.re-title{
  margin-bottom: 0px;
  border-bottom: 1px solid #E0E1E3;
  margin-top: 10px;
}
.title-name{
  font-size: 16px;
  border: 1px solid #FFF;
  color: #828A90;
  font-weight: bold;
  outline: none;
  background: #DDD;
}
a{
  color: #730049
}
.tab-content{
  padding-top: 10px;
}
.table-content{
  margin-top: 10px;
}
.form-content{
  margin-top: 30px;
}
.hr-line {
  height:1px;border:none;border-top:1px dashed #808080;
  margin-top: 15px;
}
.form-body{
  margin-top:  10px;
  padding: 0 20px;
}

.el-row {
  margin-bottom: -7px;
  display: flex;
  flex-wrap: wrap
}

.item .el-form-item__label{
  color: #828A90;
  font-size: 12px !important;

}
//{
//  color: #828A90;
//}

.el-radio {
  margin-right: 10px;
}
.bottom-action {
  margin-top: 10px;
  padding-top: 10px ;
  border-top: 1px solid #E0E1E3;
}
.pull-right {
  float: right;
}
a{
  top: -2px;
  position: relative;
}

</style>